module.exports = __webpack_public_path__ + "c2b79ca8511359bc183544d56cb1d5c8.pdf";